export { default } from "./ClaimResults.gql";
